export default __webpack_public_path__ + "static/media/NTEX CLASS-6 EXAM PATTERN 2026-27.1ad79b65.pdf";